export enum NotificationSettings {
  Off = 'off',
  Less = 'less',
  On = 'on',
}
